module.exports = __webpack_public_path__ + "img/n3statistics.58e24477.svg";